import { render } from "./ReusedVoucherPreview.vue?vue&type=template&id=253fa3b2&scoped=true"
import script from "./ReusedVoucherPreview.vue?vue&type=script&lang=ts"
export * from "./ReusedVoucherPreview.vue?vue&type=script&lang=ts"

import "./ReusedVoucherPreview.vue?vue&type=style&index=0&id=253fa3b2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-253fa3b2"

export default script